<template>
    <nav class="top-navigation">
        <ul class="top-navigation__list">
            <li class="top-navigation__list-item d-md-block">
                <div class="language-switch" :class="{'language-switch--open': languageSwitchOpen}">
                    <button class="top-navigation__list-item-link top-navigation__icon--item-language icon icon--hover top-navigation__icon" @click.stop="languageSwitchOpen = !languageSwitchOpen" type="button">
                        {{ content.languageLabel }}
                    </button>
                    <div class="language-switch__context">
                        <ul class="language-switch__list">
                            <li class="language-switch__element">
                                <button class="language-switch__link" :class="{'language-switch__link--active': isActive('de')}"
                                        @click="switchLanguage('de')">
                                  <span class="language-switch__label">Deutsch</span>
                                </button>
                            </li>
                            <li class="language-switch__element">
                                <button class="language-switch__link" :class="{'language-switch__link--active': isActive('fr')}"
                                        @click="switchLanguage('fr')">
                                  <span class="language-switch__label">Français</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'content',
      'language'
    ])
  },
  methods: {
    ...mapActions([
      'setLanguage'
    ]),
    isActive(language) {
      return this.language == language;
    },
    switchLanguage(language) {
      this.languageSwitchOpen = false;
      this.setLanguage(language);
    }
  },
  data() {
    return {
      languageSwitchOpen: false
    }
  }
}

</script>

<style>

    button.language-switch__link {
      display: block;
      background-color: transparent;
      border: none;
      outline: none;
    }

    button.language-switch__link:hover {
      cursor: pointer;
    }

    .language-switch__context {
        opacity: 0;
    }

    @media (max-width: 767px) {
        .language-switch__context {
            margin-left: 25px;
            padding: 0 10px;
            background-color: white;
        }
    }
</style>
